











































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import moment from "moment";
import { FormQuestion } from "@/store/modules/types";
import DatePicker from "vuejs-datepicker";
import { BTime } from "bootstrap-vue";

@Component({
  components: {
    DatePicker,
    BTime,
  },
})
export default class DateTimeAnswer extends Vue {
  @Prop() readonly question!: FormQuestion;
  value = {
    date: null,
    time: null,
  };
  @Watch("value", { deep: true })
  onValueChanged() {
    const { value } = this;
    if (value.date && value.time) {
      this.$emit("answer", this.question.id, JSON.stringify(value));
    }
  }
  mounted() {
    const { answer } = this.question;
    if (answer.value) {
      this.value = JSON.parse(answer.value);
    }
  }
}
